export default defineNuxtRouteMiddleware(async (to) => {
  const { isProduction } = useBuildTarget();

  if (!isProduction) return;

  const nuxtApp = useNuxtApp();
  const locale = nuxtApp.$i18n.locale;
  const pagePath = cleanPagePath(to.path);

  if (pagePath === '/') {
    return navigateTo(`https://tbcbank.uz/${locale.value}/`, {
      external: true,
      redirectCode: 302,
    });
  }
});
